import {cssRule} from 'typestyle';
import {important, px} from 'csx';

cssRule('.channelCompareSelect__menu', {
    marginTop: important(0),
    marginBottom: important(0),
    borderRadius: important(0),
});

cssRule('.channelCompareSelect__control', {
    borderRadius: important(0),
    borderStyle: important('none'),
});

cssRule('.channelCompareSelect__control--is-focused', {
    borderColor: important('hsl(0,0%,80%)'),
});

cssRule('.channelCompareSelect__menu-list', {
    maxHeight: important(px(150) as string),
    paddingTop: important(0),
    paddingBottom: important(0),
});

cssRule('.channelCompareSelect__option', {
    padding: important('0px 8px 0px 8px'),
});

cssRule('.channelCompareSelect__multi-value', {
    borderRadius: important(0),
});

cssRule('.channelCompareSelect__multi-value__label', {
    padding: important('0px 0px 0px 6px'),
});



// WEBPACK FOOTER //
// ./src/styles/react-select-overwrite.ts